import { AbstractModel } from '../shared/abstract.model';

export class AutomationMapping extends AbstractModel {
  automationId: string;
  regoId: string;
}
